module.exports = __webpack_public_path__ + "img/slide-1.c4e8b60e.png";